import { render, staticRenderFns } from "./PasienTidakAktif5TahunDetails.vue?vue&type=template&id=74707116"
import script from "./PasienTidakAktif5TahunDetails.vue?vue&type=script&lang=js"
export * from "./PasienTidakAktif5TahunDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Project\\Work\\laporan-rl\\sembiring_rekammedis\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('74707116')) {
      api.createRecord('74707116', component.options)
    } else {
      api.reload('74707116', component.options)
    }
    module.hot.accept("./PasienTidakAktif5TahunDetails.vue?vue&type=template&id=74707116", function () {
      api.rerender('74707116', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/app/home/retensi_dan_pemusnahan/PasienTidakAktif5TahunDetails.vue"
export default component.exports